import CustomCurrencyFormat from 'components/CustomCurrencyFormat';
import React from 'react';
import RecentOrdersList from '../RecentOrdersList';

function RecentOrdersTable({ orders }) {
  const totalOrders = orders?.edges.length;
  const headers = [
    'Order Number',
    'Item Description',
    'QTY',
    'Item Price',
    'Order Total',
    'Status',
    '',
  ];
  return (
    <>
      <div className="table-container">
        <table className="table">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr className="table-header-row">
              {headers?.map((header, idx) => (
                <th key={idx} scope="col" className="table-header">
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {orders?.edges?.map((item) => {
              const order = item.node;
              return (
                <>
                  {order.lineItems?.edges?.map((item, idx) => {
                    const lineItem = item.node;
                    return (
                      <tr className="table-row" key={idx}>
                        <td className="table-data">
                          {idx === 0 && order.orderNumber}
                        </td>
                        <td className="table-data ">
                          <div className="rig-title">
                            {lineItem?.variant?.image?.originalSrc && (
                              <img draggable="false"
                                src={lineItem?.variant?.image?.originalSrc}
                                className="rig-icon"
                                alt="image"
                              />
                            )}
                            {lineItem.title || '-'}
                          </div>
                        </td>
                        <td className="table-data">{lineItem.quantity}</td>
                        <td className="table-data">
                          <CustomCurrencyFormat
                            value={lineItem?.variant?.priceV2.amount}
                          />
                        </td>
                        <td className="table-data"></td>
                        <td className="table-data"></td>
                        <td className="table-data"></td>
                      </tr>
                    );
                  })}
                  <tr className="table-row">
                    <td className="table-data"></td>
                    <td className="table-data"></td>
                    <td className="table-data"></td>
                    <td className="table-data"></td>
                    <td className="table-data">
                      <CustomCurrencyFormat value={order.totalPriceV2.amount} />
                    </td>
                    <td className="table-data">{order.status || '-'}</td>
                    <td className="table-data right">
                      <a className="view-link" href={order.statusUrl}>
                        View
                      </a>
                    </td>
                  </tr>
                </>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="list-container">
        <RecentOrdersList orders={orders} />
      </div>
      <div className="paginate">
        1-{totalOrders > 5 ? '5' : totalOrders} of {totalOrders} entries
      </div>
      <style jsx>{`
        .table-container {
          display: block;
        }
        .list-container {
          display: none;
        }
        .table-container {
          width: 100%;
          overflow-x: auto;
          position: relative;
        }
        .rig-title {
          display: flex;
          gap: 10px;
          align-items: center;
        }
        .rig-icon {
          background-color: white;
          border-radius: 4px;
          overflow: hidden;
          height: 48px;
        }
        .view-link {
          text-decoration: underline;
          cursor: pointer;

          font-family: 'Roboto-Medium';
          font-size: 13px;
          font-weight: 400;
          line-height: 20px;
          letter-spacing: 0em;
          text-align: right;
          color: #ffffff;
        }
        .paginate {
          margin-top: 24px;
          font-size: 13px;
          font-weight: 400;
          line-height: 20px;
          letter-spacing: 0em;
          text-align: left;
          color: #949494;
          font-family: 'Roboto-Medium';
        }
        .table-header-row {
          text-transform: uppercase;
          white-space: nowrap;
        }
        .table-row {
          width: 100%;
          background: #141414;
          border-radius: 2px;
          border-bottom: #000000 1px solid;
          white-space: nowrap;
        }
        .table-row-unique {
          width: 100%;
          white-space: nowrap;
        }
        .table-row-group {
          width: 100%;
        }
        .table {
          width: 100%;
          text-align: left;
          font-family: 'Roboto-Medium';
          border-collapse: collapse;
        }
        .table-header {
          font-size: 13px;
          font-weight: 600;
          line-height: 24px;
          letter-spacing: 0em;
          text-align: left;
          padding: 16px 24px;
        }

        .table-data {
          font-size: 13px;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 0em;
          text-align: left;
          padding: 16px 24px;
        }
        .right {
          text-align: right;
        }
        @media (max-width: 1439px) {
          .table-container {
            display: none;
          }
          .list-container {
            display: block;
          }
        }
        @media (max-width: 991px) {
          .table-container {
            display: block;
          }
          .list-container {
            display: none;
          }
        }
        @media (max-width: 944px) {
          .table-container {
            display: none;
          }
          .list-container {
            display: block;
          }
        }
      `}</style>
    </>
  );
}

export default RecentOrdersTable;
